import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const formSchema = yup.object().shape({
  equipmentCodeId: yup.lazy((value) => {
    if (value !== undefined) {
      return yup.string().required('Equipment Code is required');
    }
    return yup.mixed().notRequired();
  }),
  associationTypeCode: yup.string().required('Association type is required'),

  // inputTypeCodes C, F, N, P, R
  inputTypeCode: yup.string().when('associationTypeCode', {
    is: (associationTypeCode) => associationTypeCode === 'S',
    then: yup.string().required('Input type is required'),
    otherwise: yup.string(),
  }),

  criteriaCode: yup.lazy((value, { parent: { inputTypeCode } }) => {
    if (inputTypeCode !== 'N') {
      return yup.mixed().notRequired();
    }
    if (value !== undefined) {
      return yup.string().required('Criteria is required');
    }
    return yup.mixed().notRequired();
  }),

  unitCode: yup.lazy((value, { parent: { inputTypeCode } }) => {
    if (inputTypeCode !== 'N' && inputTypeCode !== 'R') {
      return yup.mixed().notRequired();
    }
    if (value !== undefined) {
      return yup.string().required('Unit is required');
    }
    return yup.mixed().notRequired();
  }),

  lowerBound: yup.lazy((value, { parent: { inputTypeCode, criteriaCode } }) => {
    if (
      (inputTypeCode !== 'N' && inputTypeCode !== 'R') ||
      (inputTypeCode === 'N' && criteriaCode === 'ANY')
    ) {
      return yup.mixed().notRequired();
    }
    if (value !== undefined) {
      return yup
        .number()
        .typeError('Must be a number')
        .moreThan(0, 'Must be greater than 0')
        .required('Numerical value is required');
    }
    return yup.mixed().notRequired();
  }),

  upperBound: yup.lazy((value, { parent: { inputTypeCode, lowerBound } }) => {
    if (inputTypeCode !== 'R') {
      return yup.mixed().notRequired();
    }
    if (value !== undefined) {
      return yup
        .number()
        .typeError('Must be a number')
        .moreThan(lowerBound, `Must be greater than ${lowerBound}`)
        .required('Numerical value 2 is required');
    }
    return yup.mixed().notRequired();
  }),

  preDefinedValue: yup.lazy((value, { parent: { inputTypeCode } }) => {
    if (inputTypeCode === 'P') {
      return yup
        .object()
        .test(
          'is-predefined-value-valid',
          'Predefined values are required',
          (val) => val?.value?.length > 0,
        );
    }
    return yup.mixed().notRequired();
  }),
});
